// ----------------------------------------------------------------------


function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';
const ROOTS_PAGE = '/';
const ROOTS_FEATURED = '/featured';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  register: path(ROOTS_AUTH, '/register'),
  registerIndividual: path(ROOTS_AUTH, '/register-individual'),
  registerCorporate: path(ROOTS_AUTH, '/register-corporate'),
  registerVolunteer: path(ROOTS_AUTH, '/register-volunteer'),
  registerNonprofit: path(ROOTS_AUTH, '/register-nonprofit'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  verify: path(ROOTS_AUTH, '/verify'),
  verifyConfirmation: path(ROOTS_AUTH, '/verify/confirmation'),
  verifyResendVerification: path(ROOTS_AUTH, '/verify/resend-verification'),
  verifyResendConfirmation: path(ROOTS_AUTH, '/verify/resend-confirmation'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  resetPasswordConfirm: path(ROOTS_AUTH, '/reset-password/confirm'),
  promoteNewPassword: path(ROOTS_AUTH, '/promote-password'),
  promoteNewPasswordConfirm: path(ROOTS_AUTH, '/promote-password/confirm'),
};

export const PATH_PAGE = {
  root: ROOTS_PAGE,
  profile: '/profile',
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  SuccessStories: '/success-stories',
  ProjectAKAP: '/featured/operation-small-comforts',
  Volunteering: '/featured/volunteering',
  SuccessStoriesDetails: '/success-stories-details',
  project: '/project',
  projectCause: '/explore-project',
  projectDetails: '/project-details',
  charity: '/charity',
  faqs: '/faqs',
  page404: '/404',
  page500: '/500',
  components: '/components',
};

export const PATH_FEATURED = {
  root: ROOTS_FEATURED,
  projectAkap: path(ROOTS_FEATURED, '/project-akap'),
  scholarshipProgram: path(ROOTS_FEATURED, '/scholarship-program'),
  projectSponsorship: path(ROOTS_FEATURED, '/project-sponsorship'),
  annualCharityWork2026: path(ROOTS_FEATURED, '/annual-charity-work'),
  calamityAssistance: path(ROOTS_FEATURED, '/calamity-assistance'),
  volunteering: path(ROOTS_FEATURED, '/volunteering'),
  operationSmallComforts: path(ROOTS_FEATURED, '/operation-small-comforts'),
  screensOfHope: path(ROOTS_FEATURED, '/screens-of-hope'),
}

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    app: path(ROOTS_DASHBOARD, '/app'),
    ecommerce: path(ROOTS_DASHBOARD, '/ecommerce'),
    analytics: path(ROOTS_DASHBOARD, '/analytics'),
    banking: path(ROOTS_DASHBOARD, '/banking'),
    booking: path(ROOTS_DASHBOARD, '/booking'),
  },
  mail: {
    root: path(ROOTS_DASHBOARD, '/mail'),
    all: path(ROOTS_DASHBOARD, '/mail/all'),
  },
  chat: {
    root: path(ROOTS_DASHBOARD, '/chat'),
    new: path(ROOTS_DASHBOARD, '/chat/new'),
    view: (name) => path(ROOTS_DASHBOARD, `/chat/${name}`),
  },
  calendar: path(ROOTS_DASHBOARD, '/calendar'),
  kanban: path(ROOTS_DASHBOARD, '/kanban'),
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    new: path(ROOTS_DASHBOARD, '/user/new'),
    list: path(ROOTS_DASHBOARD, '/user/list'),
    cards: path(ROOTS_DASHBOARD, '/user/cards'),
    profile: path(ROOTS_DASHBOARD, '/user/profile'),
    account: path(ROOTS_DASHBOARD, '/user/account'),
    edit: (name) => path(ROOTS_DASHBOARD, `/user/${name}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, `/user/reece-chung/edit`),
  },
  eCommerce: {
    root: path(ROOTS_DASHBOARD, '/e-commerce'),
    shop: path(ROOTS_DASHBOARD, '/e-commerce/shop'),
    list: path(ROOTS_DASHBOARD, '/e-commerce/list'),
    checkout: path(ROOTS_DASHBOARD, '/e-commerce/checkout'),
    new: path(ROOTS_DASHBOARD, '/e-commerce/product/new'),
    view: (name) => path(ROOTS_DASHBOARD, `/e-commerce/product/${name}`),
    edit: (name) => path(ROOTS_DASHBOARD, `/e-commerce/product/${name}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-blazer-low-77-vintage/edit'),
    demoView: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-air-force-1-ndestrukt'),
  },
  invoice: {
    root: path(ROOTS_DASHBOARD, '/invoice'),
    list: path(ROOTS_DASHBOARD, '/invoice/list'),
    new: path(ROOTS_DASHBOARD, '/invoice/new'),
    view: (id) => path(ROOTS_DASHBOARD, `/invoice/${id}`),
    edit: (id) => path(ROOTS_DASHBOARD, `/invoice/${id}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, '/invoice/e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1/edit'),
    demoView: path(ROOTS_DASHBOARD, '/invoice/e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5'),
  },
  blog: {
    root: path(ROOTS_DASHBOARD, '/blog'),
    posts: path(ROOTS_DASHBOARD, '/blog/posts'),
    new: path(ROOTS_DASHBOARD, '/blog/new'),
    view: (title) => path(ROOTS_DASHBOARD, `/blog/post/${title}`),
    demoView: path(ROOTS_DASHBOARD, '/blog/post/apply-these-7-secret-techniques-to-improve-event'),
  },
};

export const PATH_DOCS = 'https://docs-minimals.vercel.app/introduction';
